import { ExclamationIcon } from "@heroicons/react/outline";

export default function ErrorCard({
  errorMsg,
  errorTitle,
  actionBtn,
}: {
  errorMsg: string;
  errorTitle: string;
  actionBtn?: JSX.Element;
}) {
  return (
    <div className="text-neutralColor-normal flex flex-col lg:flex-row items-center lg:items-start gap-6 justify-center mx-auto bg-white w-11/12 md:w-2/3 lg:w-3/5 max-w-lg shadow-2xl rounded-lg px-4 p-6">
      <span className="bg-red-100 rounded-full p-2">
        <ExclamationIcon className="lg:h-6 lg:w-6 text-tertiaryColor-normal" />
      </span>
      <div className="flex flex-col justify-center">
        <h2 className="m-0 font-bold text-center lg:text-left">{errorTitle}</h2>
        <p className="mb-5 mt-2">{errorMsg}</p>
        {actionBtn && <div>{actionBtn}</div>}
      </div>
    </div>
  );
}
